import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { ReportService } from "../services/report-service";
import { NotifyService } from "../services/notify-service";

export function CustomDashboardReport(): ng.IDirective {
    return {
        restrict: 'E',
        template: require("/assets/app/templates/custom-dashboard-report.html"),
        scope: {
            reportName: "@"
        },
        controller: CustomDashboardReportController,
        bindToController: true,
        controllerAs: 'cdrVM'
    }
}

export class CustomDashboardReportController {
    static $inject = ['$scope', 'reportService', 'charTypeIcons', 'notifyService'];

    initialized: boolean;

    name: string;
    reportName: string;
    page: number;
    rowCount: number;
    numFound: number;
    pageCount: number;

    rawItemRows: any[];

    titles: { title: string; key: string }[];

    charTypeClass: string;
    charTypeId: number;

    constructor(
        $scope: ng.IScope,
        private reportService: ReportService,
        private charTypeIcons: any,
        private notifyService: NotifyService) {

        this.rowCount = 25;
        this.page = 1;
        this.initialized = false;
        this.titles = [];

        $scope.$watchCollection(() => [this.page, this.rowCount], (newValue, oldValue) => {
            this.Search();
        });
    }

    Search() {
        this.notifyService.startProgress();
        var charTypeID: number;
        if (this.reportName == "GetInvoicesToProcess") {
            this.name = "MDNs to Process";
            charTypeID = Consts.CharTypeIDs.invoice;
        } else if (this.reportName == "GetPendingInvoices") {
            this.name = "Pending MDNs";
            charTypeID = Consts.CharTypeIDs.invoice;
        } else if (this.reportName == "GetSubmittedDNRs") {
            this.name = "DNRs Submitted (Last 10 Days)";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetTermDealsRecentActivity") {
            this.name = "Term Deals Recent Activity";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetAwaitingDNRs") {
            this.name = "DNRs Awaiting Approval";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetLicenseDealsRecentActivity") {
            this.name = "License Deals";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetRecentlyClosedDeals") {
            this.name = "Recently Closed";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetNegotiatorRecentActivity") {
            this.name = "Recent Activity";
            charTypeID = Consts.CharTypeIDs.transaction;
        } else if (this.reportName == "GetRecentActivity") {
            this.name = "Recent Activity";
            charTypeID = Consts.CharTypeIDs.transaction;
        }

        this.reportService.getCustomReport(this.reportName, this.page, this.rowCount)
            .then((res) => {
                this.processResults(charTypeID, res);
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private setCharTypeIcon(charTypeId: number) {
        for (var i = 0; i < this.charTypeIcons.length; i++) {
            var ct = this.charTypeIcons[i];
            if (ct.charTypeID == charTypeId) {
                this.charTypeClass = ct.class;
                break;
            }
        }
    }

    TestIsISODate(input: string) {
        return Utils.DateUtil.IsISODate(input);
    }

    private processResults(charTypeId: number, res: any) {
        this.charTypeId = charTypeId;
        this.setCharTypeIcon(charTypeId);

        this.rawItemRows = res.results;
        this.numFound = res.numFound;
        this.pageCount = Math.ceil(this.numFound / this.rowCount);

        if (this.titles.length == 0) {
            var first = this.rawItemRows[0];
            for (var key in first) {
                //var title = key.replace(/_/g, " ").replace(/\w\S*/g,(txt) => { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
                var title = key.replace(/_/g, " ").replace(/\w\S*/g, (txt) => { return txt; });
                if (title.toLowerCase() == "inv id" || title.toLowerCase() == "trx id" || title.toLowerCase() == "prp id") {
                    title = "ID";
                }
                this.titles.push({
                    title: title,
                    key: key
                });
            }
        }

        this.initialized = true;
    }
}
